import { ObjectAliases } from '@/entities/Object'

export type ReportTabsType = {
  id: string
  url: string
  label: string
  objects: ObjectAliases[]
}

const ReportTabsList = {
  INVENT_ACT: {
    id: 'invent_act',
    url: 'invent-act',
    label: 'itf.reports_tab.invent_act',
    objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  },
  INVENT_TO_URL: {
    id: 'invent_to_day',
    url: 'invent-to-day',
    label: 'itf.reports_tab.invent_to_day',
    objects: [ObjectAliases.GROUPS],
  },
  // READINGS: {
  //   id: 'readings',
  //   url: 'readings',
  //   label: 'itf.reports_tab.readings',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // CONS_DAYS: {
  //   id: 'consumption_days',
  //   url: 'consumption-days',
  //   label: 'itf.reports_tab.cons_days',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // CONS_PERIOD: {
  //   id: 'consumption_period',
  //   url: 'consumption-period',
  //   label: 'itf.reports_tab.cons_period',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // CONS_COMPARE: {
  //   id: 'consumption_compare',
  //   url: 'consumption-compare',
  //   label: 'itf.reports_tab.cons_compare',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // CURRENT: {
  //   id: 'current',
  //   url: 'current',
  //   label: 'itf.reports_tab.current',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // CURRENT_ARCHIVE: {
  //   id: 'current_archive',
  //   url: 'current-archive',
  //   label: 'itf.reports_tab.current_archive',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // TIME_SLICE: {
  //   id: 'time_slice',
  //   url: 'time-slice',
  //   label: 'itf.reports_tab.time_slice',
  //   objects: [ObjectAliases.CABINETS],
  // },
  // INVENTORY: {
  //   id: 'inventory',
  //   url: 'inventory',
  //   label: 'itf.reports_tab.inventory',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
  // GREEN_GLADE: {
  //   id: 'green_glade',
  //   url: 'green-glade',
  //   label: 'itf.reports_tab.green_glade',
  //   objects: [ObjectAliases.CABINETS, ObjectAliases.GROUPS],
  // },
}

export const ReportTypeUrl = {
  invent_act: 'invent-act',
  invent_to_day: 'invent-to-day',
  // readings: 'readings',
  // consumption_period: 'consumption-period',
  // consumption_days: 'consumption-days',
  // consumption_compare: 'consumption-compare',
  // current: 'current',
  // current_archive: 'current-archive',
  // time_slice: 'time-slice',
  // inventory: 'inventory',
  // green_glade: 'green_glade',
}

type ReportTypeKeys = keyof typeof ReportTabsList
export const ReportTabsTypes: Record<ReportTypeKeys, ReportTabsType> = ReportTabsList
